import axios from 'axios';
import config from '../config';
import handleServiceResponse from '../hof/handleServiceResponse';

export class Team {
    static getMembers = async (blogId) => {
        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/blogs/${blogId}/team`,
                method: 'GET'
            };
            const { data } = await axios(options)
            return data;
        })

    }

    static addMember = async (blogId, username, role) => {

        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/blogs/${blogId}/team`,
                method: 'POST',
                data: {
                    username,
                    role
                }
            };

            const { data } = await axios(options)

            return data;
        });

    }

    static removeMember = async (blogId, username) => {
        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/blogs/${blogId}/team`,
                method: 'DELETE',
                data: {
                    username
                }
            };

            const { data } = await axios(options)

            return data;
        });

    }

    static updateMember = async (blogId, username, role) => {

        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/blogs/${blogId}/team`,
                method: 'PUT',
                data: {
                    username,
                    role
                }
            };

            const { data } = await axios(options)

            return data;
        });

    }
}